import { Edit, ReferenceInput, SimpleForm, TextInput } from "react-admin";

const LocationEdit = () =>(
    <Edit>
        <SimpleForm>
            <ReferenceInput source="id" reference="locations"/>
            <TextInput source="location" label="Location" />
        </SimpleForm>
    </Edit>
);

export default LocationEdit;